'use strict';
const angular = require('angular');

/*@ngInject*/
export function departingFilter() {
  return function(input, query) {
    input = input || '';
    let out = [];
    for(let value of input) {
      if(value.departing == query) {
        out.push(value);
      }
    }
    return out;
  };
}

export default angular.module('fiapiApp.departing', [])
  .filter('departing', departingFilter)
  .name;



// WEBPACK FOOTER //
// ./client/filters/departing/departing.filter.js